import { motion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { IMAGES, CONTACT } from "../../data/content";

export const Hero = () => {
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    "Hola JAN SMM, me gustaría solicitar una cotización."
  )}`;

  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${IMAGES.hero})` }}
      />
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-16 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <span className="inline-block font-body text-sm tracking-[0.25em] uppercase text-[#FF1616] border-l-2 border-[#FF1616] pl-3 mb-6">
            Mantenimiento y Servicio Minero
          </span>
          <h1 className="font-heading font-black uppercase text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tight">
            Potencia que <span className="text-[#FF1616]">no se detiene</span> en la mina
          </h1>
          <p className="font-body text-neutral-300 text-base sm:text-lg mt-6 max-w-2xl leading-relaxed">
            Reparación, diagnóstico y refacciones para motores <strong className="text-white">Deutz</strong>,{" "}
            <strong className="text-white">Cummins</strong> y <strong className="text-white">Mercedes Benz</strong>.
            Técnicos certificados al servicio de tu producción.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-10">
            <a
              href="#contacto"
              data-testid="hero-cta-cotizar"
              className="group inline-flex items-center justify-center gap-2 bg-[#FF1616] hover:bg-[#CC0F0F] text-black font-heading font-bold uppercase tracking-wider px-8 py-4 transition-colors"
            >
              Solicitar Cotización
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10 font-heading font-bold uppercase tracking-wider px-8 py-4 transition-colors"
            >
              <MessageCircle size={20} /> WhatsApp
            </a>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-14 max-w-xl border-t border-[#262626] pt-8">
            {[
              { k: "+10", v: "Años de experiencia" },
              { k: "3", v: "Marcas certificadas" },
              { k: "100%", v: "Compromiso minero" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-heading font-black text-3xl sm:text-4xl text-[#FF1616]">{s.k}</div>
                <div className="font-body text-xs uppercase tracking-wider text-neutral-400 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
